/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { MarketingGlampointsCreditResult } from './marketingGlampointsCreditResult';

export interface MarketingGlampointsBatchResponse {
  duplicated?: number;
  failed?: number;
  noGlamSubscription?: number;
  notFound?: number;
  results?: Array<MarketingGlampointsCreditResult>;
  succeeded?: number;
  total?: number;
}
